<template>
  <div class="min-h-screen">
    <PageHeader
      :title="tab === 'populations' ? 'Datasets' : 'Study Builder'"
      :subtitle="tab === 'populations'
        ? 'Compose reusable study input tables from governed DataAttributes'
        : 'Regression-based causal analysis: What influences patient outcomes?'"
      :breadcrumbs="[{ label: 'Insights' }, { label: 'Impact Analytics' }]"
    />
    <div class="p-6 pb-32">
      <DatasetCatalog
        v-if="tab === 'populations'"
        :datasets="datasets"
        :attributes="attributes"
        :loading="loading"
        @refresh="fetchCatalog"
        @attribute-saved="fetchCatalog"
      />
      <StudyBuilder
        v-else
        :attributes="attributes"
        :datasets="datasets"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DatasetCatalog from './DatasetCatalog.vue';
import StudyBuilder from './StudyBuilder.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'Impact_Analytics',
  components: { DatasetCatalog, PageHeader, StudyBuilder },
  props: {
    tab: { type: String, default: 'studies' },
  },
  data() {
    return {
      attributes: [],
      datasets: [],
      loading: false,
    };
  },
  watch: {
    tab() {
      this.fetchCatalog();
    },
  },
  mounted() {
    this.fetchCatalog();
  },
  methods: {
    async fetchCatalog() {
      this.loading = true;
      try {
        const [attributes, datasets] = await Promise.all([
          axios.get('api/impact_analytics/attributes/'),
          axios.get('api/impact_analytics/datasets/'),
        ]);
        this.attributes = attributes.data;
        this.datasets = datasets.data;
      } catch (error) {
        console.error('Error fetching Impact Analytics catalog:', error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
